import React, { useEffect, useState } from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSupabase } from '../../supabaseAuth';
import apiService from '../../services/api';

const SuspensionCheck = ({ children }) => {
  const [isSuspended, setIsSuspended] = useState(false);
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, logout } = useSupabase();
  const navigate = useNavigate();

  useEffect(() => {
    const checkSuspensionStatus = async () => {
      if (!isAuthenticated) {
        setLoading(false);
        return;
      }

      try {
        // Make a simple API call to check if user is suspended
        // We'll use the subscriptions endpoint as it's protected and commonly used
        const response = await apiService.getSubscriptions();
        
        // If we get here without error, user is not suspended
        setIsSuspended(false);
        setLoading(false);
      } catch (error) {
        // console.log('Suspension check error:', error);
        
        // Check if this is a suspension error
        if (error.response?.status === 403) {
          const errorData = error.response.data;
          if (errorData?.code === 'user_suspended') {
            setIsSuspended(true);
            setLoading(false);
            return;
          }
        }
        
        // For other errors (401, 500, etc.), don't assume suspension
        setIsSuspended(false);
        setLoading(false);
      }
    };

    checkSuspensionStatus();
  }, [isAuthenticated]);

  // Show loading state
  if (loading) {
    return (
      <Container className="py-5">
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </Container>
    );
  }

  // Show suspension message if user is suspended
  if (isSuspended) {
    return (
      <Container className="py-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <Alert variant="danger" className="text-center p-4">
              <div className="mb-3">
                <i className="bi bi-shield-exclamation" style={{ fontSize: '3rem' }}></i>
              </div>
              <h3 className="mb-3">Account Suspended</h3>
              <p className="mb-4">
                Your account has been suspended. Please contact support for assistance.
              </p>
              <div className="d-flex gap-2 justify-content-center">
                <Button 
                  variant="outline-primary"
                  onClick={() => {
                    logout();
                    navigate('/');
                  }}
                >
                  Logout
                </Button>
                <Button 
                  variant="primary"
                  href="mailto:support@getauric.dev"
                >
                  Contact Support
                </Button>
              </div>
            </Alert>
          </div>
        </div>
      </Container>
    );
  }

  // User is not suspended, show the actual content
  return children;
};

export default SuspensionCheck;